import { stepsFullPath } from "../stepsPath";

export const step10Path = "/10";
export const step10FullPath = `${stepsFullPath}${step10Path}`;
export const step10Caption = "Groups";
